import { connect } from 'react-redux';
import EntityApplicationPage from '../components/EntityApplication/EntityApplicationPage';
import hasFormstackHandoff from '../lib/formstack/hasFormstackHandoff';

// The persisted hand-off decides the experience; the domestic rule is not re-derived here, and
// neither is the flag. The flag gates the decision at account-type submit, and the outcome is
// recorded server-side as `formstackHandoffAt`. Reading it again here could not work: this runs
// during render, and an Amplitude variant that has not resolved yet would fail closed and show
// the PDF to an applicant already committed to the embedded experience.
export function mapStateToProps(state) {
  return {
    showEmbeddedExperience: hasFormstackHandoff(state),
  };
}

export default connect(mapStateToProps)(EntityApplicationPage);
